

export const builderHeading = "Build engaging classroom activities";

export const builderSubtitle =
"Design activities that drive concept clarity and student participation";

export const contentPastePlaceholder =
  "Paste assessment content or enter a topic to balance";

export const previewDocumentContent = [
  "A mixed question set on photosynthesis includes recall items, short explanations, and one application question about greenhouse experiments.",
  "Current distribution skews toward easy recall. The balancer should increase intermediate and hard application prompts while keeping vocabulary accessible for the selected grade band.",
];

export {
  familiarTopics,
  familiarTopicsHeading,
} from "../shared/familiarTopics";

export const targetFormatHeading = "TARGET FORMAT";

export const targetFormatOptions = [
{ id: "teaching-guide", label: "TEACHING GUIDE" },
{ id: "exit-ticket", label: "EXIT TICKET" },
{ id: "check-in", label: "CHECK-IN" }];


export const generateLabel = "Generate Structured Questions";

export const generateHint = "Creates a structured, classroom-ready guide balanced across Bloom's levels";

export const generatingMessage = "Balancing difficulty across Bloom's levels…";

export const defaultDifficultyBalancerConfig = {
  selectedTopicId: "",
  selectedTopicLabel: "",
  targetFormat: "teaching-guide"
};